export const BUCKET_TEXTS = {
  DESCRIPTION:
    "Buckets allow you to generate invoices with flexibility. Create custom buckets and assign assets to the relevant buckets. You will then receive separate invoices for each bucket, billed to your billing profile. Unassigned assets will be automatically added to the default buckets for that asset type.",
};
